// Google's callback hands the token over in the URL fragment, which never reaches a server.
export const HAND_OVER_FRAGMENT_KEY = 'token';
